import React from 'react';
import placeholder from '../../assets/placeholder.png';
import getCroppingQueryParams from '../util/getCroppingQueryParams';

export default class Picture extends React.PureComponent {
  componentDidMount() {
    if (this.refs.image.complete && this.props.onLoad) {
      this.props.onLoad();
    }
  }

  render() {
    const { src, alt, size, className, onLoad } = this.props;
    let imageSrc = src || placeholder;
    let highDensityImageSrc = imageSrc;

    // add on-the-fly resizing if "props.size" is set and we didn't fallback to the placeholder image
    if (size && src) {
      highDensityImageSrc += getCroppingQueryParams(size + '_x2');
      imageSrc += getCroppingQueryParams(size);
    }

    return (
      <picture>
        <source media="(min-width: 34em)" srcSet={`${highDensityImageSrc} 2x, ${imageSrc} 1x`}/>
        <img ref="image" onLoad={onLoad} className={className} src={imageSrc} alt={alt} />
      </picture>
    );
  }
}

Picture.propTypes = {
  src: React.PropTypes.string,
  alt: React.PropTypes.string,
  className: React.PropTypes.string,
  size: React.PropTypes.any,
};



// WEBPACK FOOTER //
// ./src/component/Picture.jsx